import React from 'react';
import Container from "../componants/Container";
import CNNDomestic from './shipments/CNNDomestic';
import CarbonNeutralizedShipments from './shipments/CarbonNeutralizedShipments';
import CarbonNonNeutralizedShipments from './shipments/CarbonNonNeutralizedShipments';
import LCLShipments from './shipments/LCLShipments';
import LCLShipmentsAir from './shipments/LCLShipmentsAir';
import ImportShipmentCNNPage from './shipments/ImportShipmentCNNPage';
import ImportShipmentLCLCNNPage from './shipments/ImportShipmentLCLCNNPage';
import ImportShipmentACNNPage from './shipments/ImportShipmentACNNPage';
import ImportShipmentDOMCNNFCLPage from './shipments/ImportShipmentDOMCNNFCLPage';
import ImportShipmentDOMCNNLCLPage from './shipments/ImportShipmentDOMCNNLCLPage';
const Shipment = ({ sub }) => {

  return (
    <Container>

      {sub === 'CNN' && (

        <CarbonNonNeutralizedShipments />
      )}
      {sub === 'CN' && (

        <CarbonNeutralizedShipments />
      )}
      {sub === 'LCL-CNN' && (

        <LCLShipments />
      )}
      {sub === 'LCLA-CNN' && (

        <LCLShipmentsAir />
      )}
      {sub === 'DOM-CNN' && (

        <CNNDomestic />
      )}
      {sub === 'importShipmentCNN' && (
        <ImportShipmentCNNPage />
      )}
      {sub === 'importShipmentCNNLCL' && (
        <ImportShipmentLCLCNNPage />
      )}
      {sub === 'importShipmentAIR' && (
        <ImportShipmentACNNPage />
      )}
      {sub === 'importShipmentDOMFCL' && (
        <ImportShipmentDOMCNNFCLPage />
      )}
      {sub === 'importShipmentDOMLCL' && (
        <ImportShipmentDOMCNNLCLPage />
      )}
    </Container>
  )
}

export default Shipment
